import Content from './content';
import { useTranslation } from '@CS/hooks';
import LeaderBoardButton from './WeekButton.styles';

type WeekButtonProps = {
  onClick: (index: number) => void;
  selected: boolean;
  index: number;
};

export const WeekButton = ({ index, selected, onClick }: WeekButtonProps) => {
  const onButtonClick = () => onClick(index);
  const week = useTranslation(Content.week);

  return (
    <LeaderBoardButton selected={selected} onClick={onButtonClick}>
      {week} {index + 1}
    </LeaderBoardButton>
  );
};
